import api from './api'

export const studentService = {
  fetchStudents(params = {}) {
    const query = new URLSearchParams()
    const { page = 0, size = 10, keyword } = params
    query.append('page', page)
    query.append('size', size)
    if (keyword) query.append('keyword', keyword)
    return api.get(`/students?${query.toString()}`)
  },

  fetchStudentProfile(id) {
    return api.get(`/students/${id}`)
  },

  fetchPotentialStudents(params = {}) {
    const query = new URLSearchParams()
    const { page = 0, size = 10, keyword } = params
    query.append('page', page)
    query.append('size', size)
    if (keyword) query.append('keyword', keyword)
    return api.get(`/students/potential?${query.toString()}`)
  },

  fetchPotentialStudentDetail(id) {
    return api.get(`/students/potential/${id}`)
  },

  /**
   * 管理员解绑潜在学员与系统用户（微信小程序登录身份）关联
   */
  unbindPotentialWechat(potentialStudentId) {
    return api.patch(`/students/potential/${potentialStudentId}/unbind-wechat`)
  },

  fetchMyProfile() {
    return api.get('/students/me')
  },

  fetchQuotaRecords(studentId) {
    return api.get(`/students/${studentId}/quota-records`)
  },

  unbindWechat(studentId) {
    return api.patch(`/students/${studentId}/unbind-wechat`)
  },

  // 获取所有学员数据（用于导出，不分页）
  fetchAllStudents(params = {}) {
    const query = new URLSearchParams()
    const { keyword } = params
    // 设置一个很大的size来获取所有数据
    query.append('page', 0)
    query.append('size', 10000)
    if (keyword) query.append('keyword', keyword)
    return api.get(`/students?${query.toString()}`)
  }
}

